<div class="top">
    <div class="heading">
      <span class="fw-bold">MAKE PAYMENT</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
      close
    </i>
  </div>
  
  <div class="form-wrapper">
    <form [formGroup]="walletForm" (ngSubmit)="openConfirmModal()">
      <div class="form-fields">
        <div class="payment-summary">
          {{ dialogData.paymentTitle || 'Application Fee' }} 
          <strong class="fw-bold">= {{ dialogData.paymentAmount | nairaCurrency }}</strong>
        </div>
    
        <p style="font-size: 14px">Select a payment channel</p>
    
        <div class="payment-methods">
          <label class="payment-method">
            <input
              type="radio"
              value="interswitch"
              formControlName="paymentChannel"
            />
            <img src="assets/images/interswitch-small.png" alt="interswitch" />
          </label>
        
          <label class="payment-method">
            <input
              type="radio"
              value="remita"
              formControlName="paymentChannel"
            />
            <img src="assets/images/remita.png" alt="remita" />
          </label>
        
          <label class="payment-method">
            <input
              type="radio"
              value="paystack"
              formControlName="paymentChannel"
            />
            <img src="assets/images/paystack.png" alt="paystack" />
          </label>
        </div>
        
      </div>
    
      <div class="modal-actions-wrapper">
        <button
          type="submit"
          class="custom-btn-primary w-100"
          [disabled]="walletForm.invalid"
        >
          <ng-container *ngIf="!isSubmitting; else loadingTemplate">
            <span>Continue To Payment</span>
          </ng-container>
          <ng-template #loadingTemplate>
            <span>Loading...</span>
            <div class="spinner-light"></div>
          </ng-template>
        </button>
      </div>
    </form>
    
  </div>
  